module.exports = __webpack_public_path__ + "static/cravings-0876f9235f571bfcf92e1f7f1519d991.jpg";